<div class="story-avatar">
  <div class="story-avatar__progress">
    <span class="ellipse" #ellipse>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 300 300" preserveAspectRatio="none">
        <ellipse cx="100" cy="100" rx="50" ry="100" fill="none" vector-effect="non-scaling-stroke"/>
      </svg>
    </span>
  </div>

  <div class="story-avatar__image">
    <brt-image [image]="image"></brt-image>
  </div>
</div>
